module.exports = __webpack_public_path__ + "static/media/jsonPatchAPI.89c3301a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/jsonPatchAPI.jpg
// module id = 85
// module chunks = 0